// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".actions[data-v-f0884822]{display:flex;flex-direction:column;width:100%;height:auto;padding:1.25rem 1.875rem 0 0;box-sizing:border-box;z-index:1;border:.0625rem solid #f2f2f2;padding:0 1.25rem 0;border-radius:.25rem}@media(min-width:48rem){.actions[data-v-f0884822]{margin-top:1.25rem}}.actions[data-v-f0884822] :last-child{border-bottom:none}", ""]);
// Exports
module.exports = exports;
